export default {
  BASE_URL: '',
  api: [
    // 4.0.3新增
    {
      name: 'getProjectAndSuList',
      desc: '获取查询条件数据--项目列表和业务员列表',
      method: 'GET',
      path: '/tm/payment/arrival/getProjectAndSuList'
    },
    {
      name: 'getProjectAndSuList',
      desc: '获取查询条件数据--项目列表和业务员列表',
      method: 'GET',
      path: '/tm/payment/arrival/getProjectAndSuList'
    },
    {
      name: 'projAndSuList',
      desc: '获取查询条件数据--项目列表和业务员列表',
      method: 'GET',
      path: '/tm/payment/arrival/getProj'
    },
    {
      name: 'orgList',
      desc: '获取企业列表',
      method: 'GET',
      path: '/tm/payment/arrival/orgList'
    },
    {
      name: 'projectList',
      desc: '获取项目列表',
      method: 'GET',
      path: '/tm/payment/arrival/projectList'
    },
    {
      name: 'checkBillCode',
      desc: '获取到账订单号',
      method: 'GET',
      path: '/tm/payment/arrival/checkOrder'
    },
    //
    {
      name: 'addAmount',
      desc: '新增到账填写',
      method: 'POST',
      path: '/tm/payment/arrival/addAmount'
    },
    {
      name: 'editAmount',
      desc: '新增到账填写',
      method: 'POST',
      path: '/tm/payment/arrival/addAmount/sales'
    },
    {
      name: 'getAuditList',
      desc: '获取到账确认列表',
      method: 'GET',
      path: '/tm/payment/arrival/getAuditList'
    },
    {
      name: 'getPaymentList',
      desc: '获取预付款单/尾款列表',
      method: 'GET',
      path: '/tm/payment/arrival/getPaymentList'
    },
    {
      name: 'getPaymentDetailList',
      desc: '获取预付款单明细列表',
      method: 'GET',
      path: '/tm/payment/arrival/getPaymentDetailList'
    },
    //
    {
      name: 'getProjList',
      desc: '项目变更明细',
      method: 'GET',
      path: '/tm/payment/arrival/proj/List'
    },
    //
    {
      name: 'getBillType',
      desc: '获取查询条件数据--变更类型',
      method: 'GET',
      path: '/tm/payment/arrival/getBillType'
    },
    {
      name: 'detailList',
      desc: '项目结算明细',
      method: 'GET',
      path: '/tm/payment/arrival/proj/detailList'
    },
    // 到账确认 审核 selfOrderDzd
    {
      name: 'audit',
      desc: '到账确认--审核',
      method: 'POST',
      path: '/tm/payment/arrival/audit'
    },
    {
      name: 'reject',
      desc: '到账驳回',
      method: 'POST',
      path: '/tm/payment/arrival/reject'
    },
    {
      name: 'modify',
      desc: '到账确认--修改',
      method: 'POST',
      path: '/tm/payment/arrival/modify'
    },
    {
      name: 'repeal',
      desc: '到账确认--作废',
      method: 'POST',
      path: '/tm/payment/arrival/repeal'
    },
    {
      name: 'getFinallyType',
      desc: '尾款单列表--结算状态',
      method: 'GET',
      path: '/tm/payment/getFinallyType'
    },
    {
      name: 'getBillStatus',
      desc: '获取查询条件数据--到账状态',
      method: 'GET',
      path: '/tm/payment/arrival/getBillStatus'
    },
    {
      name: 'pur',
      desc: '获取到账确认条件 -- 获取企业（客户名称）',
      method: 'GET',
      path: '/search/order/pur'
    },
    {
      name: 'selectAllProjs',
      desc: '获取到账确认条件 -- 获取项目',
      method: 'GET',
      path: '/tm/payment/arrival/selectAllProjs'
    },
    {
      name: 'getFinancial',
      desc: '获取到账确认条件 -- 获取财务人员',
      method: 'GET',
      path: '/tm/payment/arrival/getFinancial'
    },
    {
      name: 'getSuList',
      desc: '获取到账确认条件 -- 获取业务人员',
      method: 'GET',
      path: '/tm/payment/arrival/getSuList'
    },
    {
      name: 'operator',
      desc: '项目变更明细 -- 操作人',
      method: 'GET',
      path: '/tm/payment/arrival/proj/List/operator'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/api/apis/self/order/dzd.js